module.exports = __webpack_public_path__ + "img/115.dd8b5d89.png";